import { formatRpcImage } from 'pages/Home/Models/utils';

export const getFirstValue = (...values) => values.find(value => value !== undefined && value !== null && value !== '');
export const toArray = value => (Array.isArray(value) ? value : [ value ]);

const formatDateValue = value => {
    if (!value) {
        return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
};

export const formatNumber = value => {
    if (value === undefined || value === null || value === '') {
        return '—';
    }
    const number = Number(value);
    return Number.isFinite(number) ? number.toLocaleString() : value;
};

export const getPreviewImage = (model, rpcGuid) => {
    const jobType = getFirstValue(model?.job_type, model?.jobType);
    return getFirstValue(
        model?.previewURL,
        model?.preview256URL,
        model?.preview512URL,

        rpcGuid && jobType ? formatRpcImage(rpcGuid, jobType, 256, 256) : null,
    ) || null;
};


export const normalizeSuggestedModels = (selectedModels, currentRpcGuid) => {
    const seen = new Set();

    return toArray(selectedModels)
        .filter(Boolean)
        .map(model => {
            const rpcGuid = model.rpc_guid;

            return rpcGuid
                ? { ...model, rpc_guid: rpcGuid }
                : model;
        })
        .filter(model => {
            const rpcGuid = model.rpc_guid;

            if (!rpcGuid || rpcGuid === currentRpcGuid || seen.has(rpcGuid)) {
                return false;
            }

            seen.add(rpcGuid);
            return true;
        });
};

export const buildStats = serializedData => {
    const statistics = serializedData?.metadata?.statistics;
    const selectedMeshes = serializedData?.metadata?.selectedMeshes;
    const statisticsByMesh = statistics?.meshes?.meshes || [];

    if (!statistics) {
        return [];
    }

    const sumCount = type => selectedMeshes?.reduce((prev, current) => {
        const meshStats = statisticsByMesh.find(mesh => mesh.id === current.id);
        return prev + (meshStats?.[type] || 0);
    }, 0) || 0;

    const uniqueMaterialArr = [];
    const uniqueTextureArr = [];

    const getTextures = mesh => {
        mesh?.textures?.forEach(texture => {
            if (!uniqueTextureArr.includes(texture)) {
                uniqueTextureArr.push(texture);
            }
        });
    };

    selectedMeshes?.forEach(mesh => {
        if (mesh?.materialId && !uniqueMaterialArr.includes(mesh.materialId)) {
            uniqueMaterialArr.push(mesh.materialId);
        }

        getTextures(mesh);
    });

    const sumMaterials = uniqueMaterialArr.length;
    const sumTextures = uniqueTextureArr.length;

    const { materialCount, textures, meshes, vertices, triangles } = statistics;

    return [
        {
            label: 'Materials',
            value: sumMaterials || materialCount,
        },
        {
            label: 'Textures',
            value: selectedMeshes?.length > 0 ? sumTextures : textures,
        },
        {
            label: 'Meshes',
            value: selectedMeshes?.length || meshes?.count,
        },
        {
            label: 'Vertices',
            value: sumCount('vertices') !== 0 ? sumCount('vertices') : vertices,
        },
        {
            label: 'Triangles',
            value: sumCount('triangles') !== 0 ? sumCount('triangles') : triangles,
        },
    ].filter(item => item.value !== undefined && item.value !== null && item.value !== '');
};

export const buildMetadataRows = ({ selectedModel }) => {
    const metadata = [
        { label: 'Name', value: selectedModel?.title || 'Untitled model' },
        { label: 'Creator', value: selectedModel?.creator || 'ArchVision' },
        { label: 'Category', value: selectedModel?.category || '—' },
        { label: 'Subcategory', value: selectedModel?.subcategory || '—' },
        { label: 'Created', value: formatDateValue(selectedModel?.created_at) },
        { label: 'Updated', value: formatDateValue(selectedModel?.updated_at) },
    ];

    return metadata;
};